<template>
    <!-- 仓库详情 -->
    <content-view>
        <div class="storage-detail">
            <a-spin :spinning="spinning">
                <div class="mb16">仓库编码：{{detail.warehouseNo}}</div>
                <div class="mb16">仓库名称：{{detail.warehouseName}}</div>
                <div class="mb16">创建组织：{{detail.organizationCreateName}}</div>
                <div class="mb16">使用组织：{{detail.organizationName}}</div>
                <div class="mb16">仓库属性：{{detail.warehousePropertyStr}}</div>
                <div class="mb16">库存状态：{{detail.warehouseStatus}}</div>
                <div class="mb16">允许负库存：{{statusEnum[detail.isAllowMinusInventory]}}</div>
                <div class="mb16">允许MRP计划：{{statusEnum[detail.isAllowMrpPlan]}}</div>
                <div class="mb16">允许锁库：{{statusEnum[detail.isAllowLock]}}</div>
                <div class="mb16">参与预警：{{statusEnum[detail.isPreWarn]}}</div>
                <div class="mb16">启用仓位管理：{{statusEnum[detail.isPositionControl]}}</div>
                <div class="mb16">参与拣货：{{statusEnum[detail.isPartInPicking]}}</div>
            </a-spin>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const statusEnum = ['否', '是']
    import { mapGetters } from "vuex";
    export default {
        name: 'storageDetail',
        components: {},
        props: {},
        data() {
            return {
                statusEnum,
                spinning: false,
                detail: {}
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @getStorageDetail 获取仓库详情
             */
            getStorageDetail() {
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.warehouseDetail({
                    params: {
                        id 
                    }
                }).then(res => {
                    this.spinning = false;
                    this.detail = res;
                });
            }
        },
        beforeCreate() {
        },
        created() {},
        mounted() {
            this.getStorageDetail();
        }
    };
</script>
<style lang="scss">
    .storage-detail {
        background-color: #fff;
        padding: 24px;
        min-height: 70vh;
    }
</style>
